import { whiteColor } from "@config"
import React from "react"
import * as styles from "./pageMostRadio.module.scss"

import frameImg from "@images/png/14.png"
import createPage from "@src/components/page"
import { animated } from "@react-spring/web"
import { callYou, useEnteringTrail } from "@src/components/page/lib"
import { imageCdnUrl } from "@src/utils/request"
import bgImg from "@images/2022/p7/27-100.jpg"
import iconFaceImg from "@images/2022/p7/28.png"
import iconCircleImg from "@images/2022/p7/29.png"

const PageMostRadio = createPage(
  ({ offset, data }) => {
    const {
      "favorite-radio": {
        attributes: { cover, title },
      },
    } = data
    const anime1Styles = useEnteringTrail(3, offset, { type: "mt" })
    const anime2Styles = useEnteringTrail(1, offset, { step: 0.4, type: "mb" })
    const anime3Styles = useEnteringTrail(1, offset, { step: 0.9 })
    return (
      <>
        <div>
          <div className={styles.radioContainer}>
            <div className={styles.radio}>
              <animated.img
                style={anime1Styles[0]}
                src={imageCdnUrl(cover, { w: 558, h: 558 })}
                alt={title}
              />
              <animated.img
                style={anime1Styles[1]}
                src={iconCircleImg}
                className={styles.iconCircle}
                alt="icon"
              />
              <animated.img
                style={anime1Styles[2]}
                src={iconFaceImg}
                className={styles.iconFace}
                alt="icon"
              />
            </div>
          </div>
        </div>
        <div>
          <animated.div style={anime2Styles[0]}>
            <b>{title}</b>
            <div>{callYou(data)}反复听了好多次</div>
          </animated.div>
        </div>
        <animated.div className="bottomText" style={anime3Styles[0]}>
          2022 年机核全年收听次数最多的节目：
          <br />
          《艾尔登法环》玩了一周后我们的感受，游戏茶话会Vol.34
        </animated.div>
      </>
    )
  },
  {
    className: "pageLayout2",
  }
)

export const pageMostRadioData = {
  key: "mostRadio",
  bgImg,
  Page: PageMostRadio,
  shouldHide: ({ "favorite-radio": radio }) => {
    return !radio
  },
}

PageMostRadio.displayName = "PageMostRadio"
export default PageMostRadio
